import type { ComboboxItem, TabsTabProps } from "@mantine/core";
import type { FormFieldData } from "../../../../../../components/BuildingBlocks/Forms/Controllers/FormFieldController";
import { getFoerderregimeLabel } from "../../../../../../components/Paragraph6/utils/getFoerderregimeLabel";
import { FoerderRegime } from "../../../../../../types/api.types";
import type { Paragraph6GemeindeAnteilErzeugerPayload } from "../../../../Paragraph6.types";

type TabProps = TabsTabProps & { label: string; hiddenInCreateMode?: boolean };

export const PARAGRAPH_6_FOERDERREGIME_CHOICES = [
  {
    value: FoerderRegime.keine_foerderung_in_anspruch_genommen,
    label: getFoerderregimeLabel(
      FoerderRegime.keine_foerderung_in_anspruch_genommen
    )
  },
  {
    value: FoerderRegime.foerderung_ausgelaufen,
    label: getFoerderregimeLabel(FoerderRegime.foerderung_ausgelaufen)
  },
  {
    value: FoerderRegime.eeg_fixe_einspeiseverguetung,
    label: getFoerderregimeLabel(FoerderRegime.eeg_fixe_einspeiseverguetung)
  },
  {
    value: FoerderRegime.eeg_ausschreibung,
    label: getFoerderregimeLabel(FoerderRegime.eeg_ausschreibung)
  },
  {
    value: FoerderRegime.eeg_ohne_ausschreibung,
    label: getFoerderregimeLabel(FoerderRegime.eeg_ohne_ausschreibung)
  },
  {
    value: FoerderRegime.eeg_innovationsausschreibung_fixe_marktpraemie,
    label: getFoerderregimeLabel(
      FoerderRegime.eeg_innovationsausschreibung_fixe_marktpraemie
    )
  },
  {
    value: FoerderRegime.eeg_innovationsausschreibung_gleitende_marktpraemie,
    label: getFoerderregimeLabel(
      FoerderRegime.eeg_innovationsausschreibung_gleitende_marktpraemie
    )
  },
  {
    value: FoerderRegime.kwkg_zuschlag_2016_2020,
    label: getFoerderregimeLabel(FoerderRegime.kwkg_zuschlag_2016_2020)
  },
  {
    value: FoerderRegime.kwkg_zuschlag_2012,
    label: getFoerderregimeLabel(FoerderRegime.kwkg_zuschlag_2012)
  },
  {
    value: FoerderRegime.kwkg_ausschreibung,
    label: getFoerderregimeLabel(FoerderRegime.kwkg_ausschreibung)
  },
  {
    value: FoerderRegime.kwkg_zuschlag_2000_2002_2009,
    label: getFoerderregimeLabel(FoerderRegime.kwkg_zuschlag_2000_2002_2009)
  }
] as const satisfies Array<ComboboxItem>;

export const PARAGRAPH_6_GENERATOR_FORM_INPUT_DATA = {
  generator: {
    name: "generator",
    required: true,
    label: "Erzeuger",
    type: "select",
    data: [] // will be filled dynamically during runtime
  },
  community_share: {
    name: "community_share",
    required: true,
    label: "Anteil Gemeinde",
    type: "number",
    placeholder: "z. B. 1,0"
  },
  anlagenschluessel_eeg: {
    name: "anlagenschluessel_eeg",
    disabled: true,
    label: "Anlagenschlüssel EEG",
    type: "text"
  }
} as const satisfies FormFieldData<Paragraph6GemeindeAnteilErzeugerPayload>;

export enum PARAGRAPH_6_GENERATOR_FORM_TABS {
  GENERAL_INFORMATION = "allgemeine-informationen",
  HISTORY = "history"
}

export const TABS: Array<TabProps> = [
  {
    value: PARAGRAPH_6_GENERATOR_FORM_TABS.GENERAL_INFORMATION,
    label: "Allgemeine Informationen"
  },
  {
    value: PARAGRAPH_6_GENERATOR_FORM_TABS.HISTORY,
    label: "Historie",
    hiddenInCreateMode: true
  }
];
